'use client';

import { useErrorContext } from 'app/[lang]/[esite]/contexts/error-context/error-context';
import { usePriceAndFitmentContext } from 'app/[lang]/[esite]/contexts/price-and-fitment-context/price-and-fitment-context';
import { CATEGORY_SERVICE_ERROR } from 'constants/common';
import { useEffect } from 'react';

interface ErrorContextEntryProps {
  error: boolean;
  priceAndAvailabilityKey: string;
}

export const ErrorContextEntry = ({
  error,
  priceAndAvailabilityKey
}: ErrorContextEntryProps) => {
  const { errorMessage, setErrorMessage } = useErrorContext();
  const { setUrlParams } = usePriceAndFitmentContext();

  useEffect(() => {
    if (error && !errorMessage) {
      setErrorMessage(CATEGORY_SERVICE_ERROR);
      setUrlParams(priceAndAvailabilityKey);
    }
  }, [
    errorMessage,
    error,
    setErrorMessage,
    priceAndAvailabilityKey,
    setUrlParams
  ]);

  return null;
};
